import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    padding: '0 0 15px'
  },
  aplicar: {
    marginTop: '10px',
    fontWeight: 'bold'
  },
  buttonPosition: {
    textAlign: 'left'
  }
}));
